<template>
  <div ref="scheduler"></div>
</template>

<script>
import "dhtmlx-scheduler";
import "dhtmlx-scheduler/codebase/ext/dhtmlxscheduler_recurring.js";
import "dhtmlx-scheduler/codebase/ext/dhtmlxscheduler_minical.js";
export default {
  name: "scheduler",
  props: {
    events: {
      type: Array,
      default() {
        return { events: [] };
      }
    }
  },

  methods: {
    $_initSchedulerEvents: function() {
      console.log(!scheduler.$_eventsInitialized);
      if (!scheduler.$_eventsInitialized) {
        scheduler.attachEvent("onEventAdded", (id, ev) => {
          this.$emit("event-updated", id, "inserted", ev);
        });
        console.log("in");
        scheduler.attachEvent("onEventChanged", (id, ev) => {
          this.$emit("event-updated", id, "updated", ev);
        });
        scheduler.attachEvent("onEventDeleted", (id, ev) => {
          this.$emit("event-updated", id, "deleted");
        });

        scheduler.$_eventsIrywdnitialized = true;
      }
    }
  },

  mounted: function() {
    // setTimeout(() => {
    //   console.log("events i", this.events);
    // }, 4000);
  },
  computed: {
    guideEvents() {
      return this.$props.events;
    }
  },
  watch: {
    guideEvents(value) {
      console.log("value => ", value);
      scheduler.skin = "material";
      scheduler.config.header = [
        "prev",
        "date",
        "today",
        "next",
        "day",
        "week",
        "month"
      ];
      // scheduler.config.repeat_date = "%m/%d/%Y";
      // scheduler.config.include_end_by = true;
      // scheduler.config.repeat_precise = true;
      // scheduler.config.occurrence_timestamp_in_utc = true;

      scheduler.config.multi_day = true;
      scheduler.config.event_duration = 35;
      scheduler.config.occurrence_timestamp_in_utc = true;
      scheduler.config.include_end_by = true;
      scheduler.config.repeat_precise = true;
      scheduler.config.repeat_date = "%d-%m-%Y";
      scheduler.attachEvent("onLightbox", function() {
        var lightbox_form = scheduler.getLightbox(); // this will generate lightbox form
        var inputs = lightbox_form.getElementsByTagName("input");
        var date_of_end = null;
        for (var i = 0; i < inputs.length; i++) {
          if (inputs[i].name == "date_of_end") {
            date_of_end = inputs[i];
            console.log("inpoutss => ", date_of_end);
            break;
          }
        }
        console.log("hereee");
        var repeat_end_date_format = scheduler.date.date_to_str(
          scheduler.config.repeat_date
        );
        var show_minical = function() {
          if (scheduler.isCalendarVisible()) scheduler.destroyCalendar();
          else {
            scheduler.renderCalendar({
              position: date_of_end,
              date: scheduler.getState().date,
              navigation: true,
              handler: function(date, calendar) {
                date_of_end.value = repeat_end_date_format(date);
                scheduler.destroyCalendar();
              }
            });
          }
        };
        date_of_end.onclick = show_minical;
      });

      scheduler.init(this.$refs.scheduler, new Date(), "week");
      scheduler.parse(value);
      this.$_initSchedulerEvents();
      // scheduler.showLightbox(1);
    }
  },
  created() {}
};
</script>

<style lang="scss">
@import "~dhtmlx-scheduler/codebase/dhtmlxscheduler_material.css";
.dhx_cal_event.dhx_cal_editor {
  border-radius: 8px;
}
.dhx_cal_tab_first {
  margin-left: auto;
}

.dhx_cal_navline.dhx_cal_navline_flex .dhx_cal_date {
  flex-grow: unset;
  font-family: Nunito;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  display: flex;
  align-items: center;
  color: #474d52;
}
.dhx_cal_tab_first,
.dhx_cal_tab,
.dhx_cal_tab_last {
  border: none !important;

  &.active {
    background: var(--theme-color);
    border-radius: 40px;
    &:hover {
      background-color: var(--theme-color);
    }
  }
}
@media only screen and (max-width: 1023px) {
  .dhx_cal_navline.dhx_cal_navline_flex .dhx_cal_tab_last {
    margin-left: -2px;
  }
  .dhx_cal_navline.dhx_cal_navline_flex .dhx_cal_tab {
    margin-right: -7px;
  }
}
.dhx_cal_tab {
  box-shadow: 0px 4px 50px rgba(0, 0, 0, 0.08) !important;
}
.dhx_cal_tab_last {
  border-top-right-radius: 40px;
  border-bottom-right-radius: 40px;
  padding-left: 15px;
  margin-left: -15px;
  // background-color: red;
  box-shadow: 5px 4px 12px rgba(0, 0, 0, 0.08) !important;
  &.active {
    padding-left: 0;
    margin-left: 0;
  }
}
.dhx_cal_tab_first {
  padding-right: 15px;
  margin-right: -15px;
  border-top-left-radius: 40px;
  // background-color: orange;
  box-shadow: -5px 4px 12px rgba(0, 0, 0, 0.08) !important;

  border-bottom-left-radius: 40px;
  &.active {
    padding-right: 0;
    margin-right: 0;
  }
}
.dhx_title {
  border-top-right-radius: 8px !important;
  border-top-left-radius: 8px !important;
  background-color: var(--theme-color) !important;
}
.dhx_body {
  border-bottom-right-radius: 8px !important;
  border-bottom-left-radius: 8px !important;
  background-color: var(--theme-color) !important;
}
.dhx_cal_data {
  &::-webkit-scrollbar {
    width: 6px;
    margin-right: 10px;
  }

  &::-webkit-scrollbar-track {
    background-color: #fff;
  }

  &::-webkit-scrollbar-thumb {
    background: #dddddd;
    border-radius: 16px;
  }
}
.dhx_cal_light_wide {
  border-radius: 8px;
}
.dhx_cal_ltitle {
  background-color: var(--theme-color);
  border-color: var(--theme-color);
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
.dhx_cal_larea {
  padding: 15px;
}
.dhx_wrap_section {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  .dhx_cal_ltext,
  .dhx_cal_lsection {
    width: 100%;
    margin: 0;
    text-align: left;
  }
  .dhx_cal_ltext {
    textarea {
      border-radius: 8px;
    }
  }
}
.dhx_cal_light_wide .dhx_section_time {
  padding: 0 !important;
}
.dhx_cal_larea label {
  font-family: "Nunito", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  /* identical to box height */

  display: flex;
  align-items: center;

  /* Secondary */

  color: #8d99a0;
}
.dhx_cal_event.dhx_cal_editor {
  background-color: var(--theme-color);
}
.dhx_cancel_btn_set {
  border: none;
  background-color: transparent;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #474d52;
  padding: 6px 10px;
}
.dhx_cancel_btn_set:hover {
  background: none !important;
  border: none !important;
}
.dhx_save_btn_set {
  background-color: var(--theme-color);
  border-radius: 20px;
  border: 1px solid var(--theme-color);
  font-family: Nunito;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 22px;
  color: #fff;
  // padding: 7px 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  transition: none;
  max-width: 100px;
  width: 100%;
}
.dhx_save_btn_set:hover {
  border: 1px solid var(--theme-color);
  // transition: none;
}
.dhx_save_btn_set:hover div {
  border: 1px solid var(--theme-color);
  transition: none;
  background-color: var(--theme-color);
}

.dhx_delete_btn_set {
  background-color: #ef5c4a;
  border-radius: 20px;
  border: 1px solid #ef5c4a;
  font-family: Nunito;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 22px;
  color: #fff;
  // padding: 7px 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  transition: none;
  max-width: 100px;
  width: 100%;
}
.dhx_delete_btn_set:hover {
  border: 1px solid #ef5c4a;
  background-color: #ef5c4a;
  border-radius: 20px;
}
.dhx_delete_btn_set:hover div {
  border-radius: 20px;
}
.dhx_delete_btn_set:hover div {
  border: 1px solid #ef5c4a;
  transition: none;
  background-color: #ef5c4a;
}
</style>
